export const STORAGE_KEYS = {
  PLP_GRID_LAYOUT: "plpGridLayout",
  RECENT_PRODUCT_SEARCHES: "recentProductSearches",
} as const;

export const getLocalStorage = <T = unknown>(key: string): T | null => {
  const value = localStorage.getItem(key);
  return value ? JSON.parse(value) : null;
};

export const setLocalStorage = <T = unknown>(key: string, value: T) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const removeLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};
